import config from '../../config';

const pageReducer = (state = {title: null, logo: config.logo}, {type, payload}) => {
  switch (type) {
    case "SET_TITLE":
      return {...state, title: payload};

    default:
      return state;
  }
};

export default pageReducer;